import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import FormInput from 'ui-library/bs/FormInput';
import {TooltipWrapper} from 'ui-library/bs/Tooltip';
import {GRAY_DARK} from 'ui-library/Colors';
import {ElementKeyboardEvent, InputChangeEvent} from 'util/Types';

export function shouldShowWarehouseName(): boolean {
  return BenchlingConfig.SCHEMAS_ENABLE_VIEW_SYSTEM_NAME;
}

interface Props {
  editingName: string;
  field: SchemaField;
  isBeingEdited: boolean;
  isDisabled: boolean;
  onChange: (e: InputChangeEvent) => void;
  onKeyDown: (e: ElementKeyboardEvent) => void;
  formInputTooltip?: string | null;
}

export default function SchemaFieldWarehouseNameField(props: Props): JSX.Element | null {
  if (shouldShowWarehouseName()) {
    return (
      <div className="simpleDivTable-cell">
        <div className="simpleDivTable-cell-contents">
          {props.isBeingEdited && BenchlingConfig.SCHEMAS_ENABLE_CHANGE_WAREHOUSE_NAME ? (
            <TooltipWrapper tooltipTitle={props.formInputTooltip}>
              <div>
                <FormInput
                  type="text"
                  name="systemName"
                  value={props.editingName}
                  onChange={props.onChange}
                  onKeyDown={props.onKeyDown}
                  disabled={props.isDisabled}
                  autoFocus={false}
                  dataTestAttrs={{component: 'SchemaFieldWarehouseNameField', element: 'formInput'}}
                />
              </div>
            </TooltipWrapper>
          ) : (
            <span
              className={css(styles.notEditable)}
              {...getTestProps({component: 'SchemaFieldWarehouseNameField', element: 'nameDisplay'})}
            >
              {props.field.systemName}
            </span>
          )}
        </div>
      </div>
    );
  }
  return null;
}

const styles = StyleSheet.create({notEditable: {color: GRAY_DARK}});
